import { NgModule } from "@angular/core";
import { LoginFormModule } from "@gloria-public/login/views/components/login-form/login-form.module";
import { LoginPageComponent } from "./login-page.component";

@NgModule({
  declarations: [LoginPageComponent],
  providers: [],
  imports: [LoginFormModule],
})
export class LoginPageModule {}
